export const qxxList = [
    { key: 1, permission_name: 'permission_name1', permission_desc: 'permission_desc1' },
    { key: 2, permission_name: 'permission_name2', permission_desc: 'permission_desc2' },
    { key: 3, permission_name: 'permission_name3', permission_desc: 'permission_desc3' },
    { key: 10, permission_name: 'permission_name10', permission_desc: 'permission_desc10' },
    { key: 7, permission_name: 'permission_name7', permission_desc: 'permission_desc7' },
    { key: 8, permission_name: 'permission_name8', permission_desc: 'permission_desc8' },
    { key: 12, permission_name: 'permission_name12', permission_desc: 'permission_desc12' },
    { key: 9, permission_name: 'permission_name9', permission_desc: 'permission_desc9' },
    { key: 4, permission_name: 'permission_name4', permission_desc: 'permission_desc4' },
    { key: 5, permission_name: 'permission_name5', permission_desc: 'permission_desc5' },
    { key: 6, permission_name: 'permission_name6', permission_desc: 'permission_desc6' },
    { key: 11, permission_name: 'permission_name11', permission_desc: 'permission_desc11' },
    { key: 13, permission_name: 'permission_name13', permission_desc: 'permission_desc13' },
    { key: 14, permission_name: 'permission_name14', permission_desc: 'permission_desc14' },
    { key: 15, permission_name: 'permission_name15', permission_desc: 'permission_desc15' },
]

export const fixMenus = (menus, permissions) => {
    if (permissions) {
        menus.map((m, index) => {
            if (!permissions.includes(m.per)) {
                delete menus[index]
            }
            return true
        })
    }
    return menus;
}

export const checkPasswordComplexity = (password) => {
    const hasLowerCase = /[a-z]/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChars = /[~!@#$%^&*();:'",.+-?/～@#¥%……&*（）、；：‘“，。？/——_=":{}|<>]/.test(password);

    // 计算满足的条件数量
    const conditionsMet = [hasLowerCase, hasUpperCase, hasNumbers, hasSpecialChars].filter(Boolean).length;

    return conditionsMet >= 4;
}

export const generatePassword = (length = 16) => {
    const charSets = {
        upper: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        lower: 'abcdefghijklmnopqrstuvwxyz',
        numbers: '0123456789',
        symbols: '!@#$%^&*()-_=+[]{}|;:,.<>?'
    };

    const allChars = Object.values(charSets).join('');

    // 获取加密安全的随机整数 [0, max)
    const getSecureRandomInt = (max) => {
        const array = new Uint32Array(1);
        crypto.getRandomValues(array);
        return array[0] % max;
    };

    const password = [];

    // 1. 保证 4 种字符类型各至少出现一次
    for (const set of Object.values(charSets)) {
        password.push(set[getSecureRandomInt(set.length)]);
    }

    // 2. 剩余位置从全部字符中随机填充
    for (let i = 4; i < length; i++) {
        password.push(allChars[getSecureRandomInt(allChars.length)]);
    }

    // 3. Fisher-Yates 洗牌算法打乱顺序，避免固定位置规律
    for (let i = password.length - 1; i > 0; i--) {
        const j = getSecureRandomInt(i + 1);
        [password[i], password[j]] = [password[j], password[i]];
    }

    return password.join('');
}
